import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import ScrollArea from "../../../../../../../../../PageHome/containers/SectionOurPickedComments/components/ScrollArea";

import styles from "./index.module.scss";

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

type ForwardedProps = Omit<React.HTMLAttributes<HTMLElement>, keyof OwnProps>;

type Props = OwnProps & ForwardedProps;

export function Root({
  className,
  style,
  content,
  children = content,
  ...others
}: Props) {
  return (
    <div className={cx(styles.root, className)} style={style} {...others}>
      {children}
    </div>
  );
}

export function Head({
  className,
  style,
  content,
  children = content,
  ...others
}: Props) {
  return (
    <div className={cx(styles.head, className)} style={style} {...others}>
      {children}
    </div>
  );
}

export function Body({
  className,
  style,
  content,
  children = content,
  ...others
}: Props) {
  return (
    <div className={cx(styles.body, className)} style={style} {...others}>
      <ScrollArea className={styles.scrollArea} fill>
        <Flex.Col gap="12px" minWidth="0">
          {children}
        </Flex.Col>
      </ScrollArea>
    </div>
  );
}

export function Row({
  className,
  style,
  content,
  children = content,
  ...others
}: Props) {
  return (
    <div className={cx(styles.row, className)} style={style} {...others}>
      {children}
    </div>
  );
}

export function Cell({
  className,
  style,
  content,
  children = content,
  ...others
}: Props) {
  return (
    <div className={cx(styles.cell, className)} style={style} {...others}>
      {children}
    </div>
  );
}

const TableBid = {
  Root,
  Head,
  Body,
  Row,
  Cell,
};

export default TableBid;
